import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { EnvironmentService } from './environment.service'
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { IElavonPayerReferenceDtoModel, IElavonPayerReferencePublicDtoModel, IPaymentRequestDtoModel } from "../models/payment/dto/payment-request-dto.model";
import { IPaymentModel } from "../models/payment/payment.model";
import { ApplicationContextService } from "./application-context.service";
import { IPaymentReponsetDtoModel } from "../models/payment/dto/payment-response-dto.model";
import { CoreService } from "./customer-core.service";

@Injectable({
    providedIn: 'root'
 })
export class PaymentService {
   constructor(private readonly httpClient: HttpClient,
               public envService: EnvironmentService,
               private applicationContext: ApplicationContextService,
               private customerService: CoreService) {}
   
   private path() {
      if (this.applicationContext.isPublic()) {
         return `${this.envService.settings.publicApiUrl}/Customers/payment`;
      }

      return `${this.envService.settings.apiUrl}/Customers`;
   }

   public get(customerId: string): Observable<IPaymentModel> {
      if (this.applicationContext.isPublic()) {
         return this.httpClient.get<IPaymentRequestDtoModel>(`${this.path()}?customerId=${this.customerService.getCustomerId(customerId)}`).pipe(
            map(dto => dto as unknown as IPaymentModel)
         );
      }

      return this.httpClient.get<IPaymentRequestDtoModel>(`${this.path()}/${customerId}/payment`).pipe(
         map(dto => dto as unknown as IPaymentModel)
      );
   }

   public update(customerId: string, model: IPaymentModel): Observable<IPaymentRequestDtoModel> {
      const dto = {
         customerId: customerId,
         defaultPaymentMethodCode: model.defaultPaymentMethod.code,
         isCreditAccount: model.isCreditAccount,
         isOnStop: model.isOnStop,
         isReleasePicksWithoutPayment: model.isReleasePicksWithoutPayment
      } as IPaymentRequestDtoModel;

      if (this.applicationContext.isPublic()) {
         return this.httpClient.put<IPaymentRequestDtoModel>(`${this.path()}?customerId=${this.customerService.getCustomerId(customerId)}`, dto);
      }

      return this.httpClient.put<IPaymentRequestDtoModel>(`${this.path()}/${customerId}/payment`, dto);
   }

   public updateElavonPayerReference(customerId: string, elavonPayerRef: string): Observable<IPaymentReponsetDtoModel> {
      let dto = {
         customerId: customerId,
         elavonPayerReference: elavonPayerRef,
      } as IElavonPayerReferenceDtoModel;

      let publicDto = {
         elavonPayerReference: elavonPayerRef
      } as IElavonPayerReferencePublicDtoModel;

      if (this.applicationContext.isPublic()) {

         return this.httpClient.put<IPaymentReponsetDtoModel>(`${this.path()}/elavonPayerRef?customerId=${this.customerService.getCustomerId(customerId)}`, publicDto);
      }

      return this.httpClient.put<IPaymentReponsetDtoModel>(`${this.path()}/${customerId}/payment/elavonPayerReference`, dto);
   }
}